export default __webpack_public_path__ + "static/media/Logo-01.ddeb4c6d.png";